import { useTranslation } from 'next-i18next/pages';

import { TranslationNamespace } from '@/i18n';

import { ApplicationsIcon, BoxIcon, DocumentIcon } from './icons';

export default function StorageObjective() {
	const t = useTranslation(TranslationNamespace.Marketing).t;
	return (
		<section className="storage-section2">
			<div className="containerWarehouse">
				<div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
					<h2
						className="section-title storage-section2-title"
						dangerouslySetInnerHTML={{
							__html: t('storage.storage-objective.how-does-fishplace-br-help-warehouses'),
						}}
					/>
					<p
						className="section-subtitle"
						dangerouslySetInnerHTML={{
							__html: t(
								'storage.storage-objective.our-goal-is-to-make-warehouses-available-to-stockers-br-increasing-unifo',
							),
						}}
					/>
				</div>
				<div className="sm:mt-[6rem] mt-[3.5rem] flex sm:flex-row flex-col gap-[2.4rem]">
					<div className="storage-section2-card">
						<BoxIcon />
						<div>
							<h3>{t('storage.storage-objective.increased-occupancy-rate')}</h3>
							<p>
								{t('storage.storage-objective.track-warehouse-capacity-utilization-in-real-time')}
							</p>
						</div>
					</div>
					<div className="storage-section2-card">
						<ApplicationsIcon />
						<div>
							<h3>{t('storage.storage-objective.work-with-requests')}</h3>
							<p>
								{t(
									'storage.storage-objective.online-receipt-and-processing-of-requests-for-loading-storage-and-shipme',
								)}
							</p>
						</div>
					</div>
					<div className="storage-section2-card">
						<DocumentIcon />
						<div>
							<h3>{t('storage.storage-objective.online-document-management')}</h3>
							<p>
								{t(
									'storage.storage-objective.transparent-exchange-of-documents-using-electronic-signature',
								)}
							</p>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
